import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'disablePickupTimeSelection',
  initialState: false,
  reducers: {
    setDisablePickupTimeSelection(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setDisablePickupTimeSelection } = slice.actions;

export default slice.reducer;
